import { EyeIcon } from '@heroicons/react/outline'

import { UserBaseInfo } from 'types/userTypes'

import { old_COLOR } from 'styles/constants/old_color'
import { old_SPACE } from 'styles/constants/old_space'

import FlexBox from '../FlexBox/FlexBox'

type Props = {
  members: UserBaseInfo[]
}

export default function MemberDropdownSection({ members }: Props) {
  return (
    <FlexBox
      borderTop={`1px solid ${old_COLOR.coolGray300}`}
      marginTop={old_SPACE.sp8}
      flexDirection="column"
      color={old_COLOR.coolGray500}
      paddingY={old_SPACE.sp8}
      fontWeight={500}
      gap={old_SPACE.sp8}
      style={{ cursor: 'default' }}
    >
      <FlexBox
        marginLeft={old_SPACE.sp8}
        marginTop={old_SPACE.sp8}
        gap={old_SPACE.sp4}
        alignItems="center"
      >
        <EyeIcon width={old_SPACE.sp14} height={old_SPACE.sp14} />
        <span>View-only permissions:</span>
      </FlexBox>
      {members.map((member, i) => {
        return (
          <FlexBox
            marginLeft={old_SPACE.sp26}
            color={old_COLOR.coolGray600}
            key={i}
          >
            {member.firstName} {member.lastName}
          </FlexBox>
        )
      })}
    </FlexBox>
  )
}
